// extracted by mini-css-extract-plugin
export default {"label":"MaskedInput__label--jgJLH","error":"MaskedInput__error--oKeeh","inputCurrency":"MaskedInput__inputCurrency--RiGAj","currencyCode":"MaskedInput__currencyCode--acfl5"};